import { PersonalNameOrder } from '../enums/personal-name-order.enum';
import { SupportedLocale } from '../enums/supported-locale.enum';
import { getSupportedLocaleMetadata } from './get-supported-locale-metadata.helper';
export function formatPersonalName({ familyName, givenName }, locale = SupportedLocale.ENGLISH) {
    const metadata = getSupportedLocaleMetadata(locale);
    switch (metadata.personalNameOrder) {
        case PersonalNameOrder.EASTERN:
            return `${familyName} ${givenName}`;
        case PersonalNameOrder.WESTERN:
        default:
            return `${givenName} ${familyName}`;
    }
}
